import Reactions from './Reactions';

export type { ReactionsProps } from './Reactions.types';
export default Reactions;
